import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import MyListItem, { MyListItemProps } from "./MyListItem";
import { iKanbanItem } from './types';

interface MySortableListItemProps extends MyListItemProps {
}

export function MySortableListItem({ item, ...props }: MySortableListItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition, } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <MyListItem ref={setNodeRef} style={style} {...attributes} {...listeners} item={item} {...props} />
  );
}

export default MySortableListItem;
